// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { HoursAndPreferencesSections } from "../web-settings";

import { GoalsWrapper } from "@components/goals-wrapper";
import { ProBadge } from "@clockwise/web-commons/src/ui/pro-badge";

// util
import { getFeatureGridFromOrg } from "@util/feature-grid.util";
// import { logger } from "@util/logger.util";

// styles
// import { colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";

// material-ui
import { Typography } from "@material-ui/core";
// import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Meeting Break Settings
// ~-~-~-~-~-~-~-
interface WebSettingsMeetingBreakProps {
  org: ISchema.IOrg;
}

// const useStyles = makeStyles({});

export const WebSettingsMeetingBreak = (props: WebSettingsMeetingBreakProps) => {
  // const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-

  const feautreGrid = getFeatureGridFromOrg(props.org);
  const meetingReliefSettingVisibility = feautreGrid?.featureStates.meetingReliefSettingVisibility;

  return (
    <div cw-id={`web-settings-${HoursAndPreferencesSections.MeetingBreak}`} className="cw-mb-16">
      <Typography variant="h3" className="cw-mb-4">
        Should Clockwise try to spread out consecutive meetings?
        {meetingReliefSettingVisibility !==
          ISchema.MeetingReliefSettingVisibility.ShowWithoutBadge && (
          <span style={{ marginLeft: 10 }}>
            <ProBadge />
          </span>
        )}
      </Typography>
      <GoalsWrapper org={props.org} isWebSettings />
    </div>
  );
};
